import React from 'react';

import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';

import NotificationService from './NotificationService';


const AchievementNotificationService = () => {
  if (!UserStore.hasCF(allUserGroups.ACHIEVEMENTS_SECTION) &&
      !UserStore.hasCF(allUserGroups.ACHIEVEMENTS_SECTION_POLLING)) {
    return null;
  }

  return <NotificationService />;
};

export default AchievementNotificationService;
